<template>
  <main>
    <div class="banner-section">
      <div class="container">
        <div class="row">
          <div class="col-8">
            <p
              class="top-text"
              v-text="page.acf.banner_top_text"
            />
            <h1
              class="banner-text"
              v-html="page.acf.banner_text"
            />
            <div
              class="sub-text"
              v-html="page.acf.banner_sub_text"
            />

            <div
              class="btn"
              @click="showEmbedModal(embed)"
              @keypress="showEmbedModal(embed)"
            >
              Watch Now
            </div>
          </div>

          <div class="col-4">
            <RysResponsiveImage
              :img="page.acf.banner_image"
              class="desktop"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="middle container">
      <div class="row">
        <div class="container middle-embed">
          <div>
            <p>Congratulations to the 2023 Retool Your School winners. 30 HBCUs won Campus Improvement Grants, 10 HBCUs won Innovation Lounge Grants, and 4 schools won both. We look forward to all the upcoming projects to improve your campuses.</p>
          </div>

          <div class="winners">
            <div>
              <h2>Cluster 1</h2>

              <div class="container">
                <BarChart
                  ref="c1"
                  :cluster="1"
                  :pause="c1_pause"
                />
              </div>

              <ol class="cluster">
                <li class="school">
                  <div class="school-name">
                    School
                  </div>
                  <div class="votes">
                    Total Votes
                  </div>
                  <div class="prize">
                    Grant Amount
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Alabama A&M University
                  </h3>
                  <div class="votes">
                    842,219
                  </div>
                  <div class="prize">
                    $150,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Jackson State University
                  </h3>
                  <div class="votes">
                    758,183
                  </div>
                  <div class="prize">
                    $100,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Albany State University
                  </h3>
                  <div class="votes">
                    496,395
                  </div>
                  <div class="prize">
                    $80,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Howard University
                  </h3>
                  <div class="votes">
                    423,026
                  </div>
                  <div class="prize">
                    $60,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Hampton University
                  </h3>
                  <div class="votes">
                    271,490
                  </div>
                  <div class="prize">
                    $60,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Grambling State University
                  </h3>
                  <div class="votes">
                    237,272
                  </div>
                  <div class="prize">
                    $50,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Alabama State University
                  </h3>
                  <div class="votes">
                    196,798
                  </div>
                  <div class="prize">
                    $50,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Southern University and A&M College
                  </h3>
                  <div class="votes">
                    163,058
                  </div>
                  <div class="prize">
                    $40,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Winston-Salem State University
                  </h3>
                  <div class="votes">
                    156,479
                  </div>
                  <div class="prize">
                    $40,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Norfolk State University
                  </h3>
                  <div class="votes">
                    148,587
                  </div>
                  <div class="prize">
                    $40,000
                  </div>
                </li>
              </ol>
            </div>

            <div>
              <h2>Cluster 2</h2>

              <div class="container">
                <BarChart
                  ref="c2"
                  :cluster="2"
                  :pause="c2_pause"
                />
              </div>

              <ol class="cluster">
                <li class="school">
                  <div class="school-name">
                    School
                  </div>
                  <div class="votes">
                    Total Votes
                  </div>
                  <div class="prize">
                    Grant Amount
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Coahoma Community College
                  </h3>
                  <div class="votes">
                    622,599
                  </div>
                  <div class="prize">
                    $150,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    South Carolina State University
                  </h3>
                  <div class="votes">
                    577,369
                  </div>
                  <div class="prize">
                    $100,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Tuskegee University
                  </h3>
                  <div class="votes">
                    560,578
                  </div>
                  <div class="prize">
                    $80,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Bethune-Cookman University
                  </h3>
                  <div class="votes">
                    420,751
                  </div>
                  <div class="prize">
                    $60,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Kentucky State University
                  </h3>
                  <div class="votes">
                    345,727
                  </div>
                  <div class="prize">
                    $60,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Benedict College
                  </h3>
                  <div class="votes">
                    250,336
                  </div>
                  <div class="prize">
                    $50,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Savannah State University
                  </h3>
                  <div class="votes">
                    209,384
                  </div>
                  <div class="prize">
                    $50,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    University of Arkansas at Pine Bluff
                  </h3>
                  <div class="votes">
                    198,740
                  </div>
                  <div class="prize">
                    $40,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    University of Maryland Eastern Shore
                  </h3>
                  <div class="votes">
                    184,834
                  </div>
                  <div class="prize">
                    $40,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Mississippi Valley State University
                  </h3>
                  <div class="votes">
                    180,712
                  </div>
                  <div class="prize">
                    $40,000
                  </div>
                </li>
              </ol>
            </div>

            <div>
              <h2>Cluster 3</h2>

              <div class="container">
                <BarChart
                  ref="c3"
                  :cluster="3"
                  :pause="c3_pause"
                />
              </div>

              <ol class="cluster">
                <li class="school">
                  <div class="school-name">
                    School
                  </div>
                  <div class="votes">
                    Total Votes
                  </div>
                  <div class="prize">
                    Grant Amount
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Fisk University
                  </h3>
                  <div class="votes">
                    803,281
                  </div>
                  <div class="prize">
                    $150,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Tougaloo College
                  </h3>
                  <div class="votes">
                    678,420
                  </div>
                  <div class="prize">
                    $100,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Johnson C. Smith University
                  </h3>
                  <div class="votes">
                    624,766
                  </div>
                  <div class="prize">
                    $80,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Lane College
                  </h3>
                  <div class="votes">
                    571,701
                  </div>
                  <div class="prize">
                    $60,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Texas College
                  </h3>
                  <div class="votes">
                    553,288
                  </div>
                  <div class="prize">
                    $60,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Southwestern Christian College
                  </h3>
                  <div class="votes">
                    364,219
                  </div>
                  <div class="prize">
                    $50,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Wilberforce University
                  </h3>
                  <div class="votes">
                    289,222
                  </div>
                  <div class="prize">
                    $50,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Morris Brown College
                  </h3>
                  <div class="votes">
                    256,727
                  </div>
                  <div class="prize">
                    $40,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Rust College
                  </h3>
                  <div class="votes">
                    246,626
                  </div>
                  <div class="prize">
                    $40,000
                  </div>
                </li>
                <li class="school">
                  <h3 class="school-name">
                    Saint Augustine's University
                  </h3>
                  <div class="votes">
                    236,403
                  </div>
                  <div class="prize">
                    $40,000
                  </div>
                </li>
              </ol>
            </div>

            <WpContent
              class="post-content"
              :content="page.content.rendered"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import BarChart from '@/components/BarChart.vue';
import EmbedModal from '@/components/modals/EmbedModal.vue';
import WpContent from '@/components/WpContent.vue';
import yoastToVueMeta from '@/utils/yoast-to-vue-meta';

export default {
  name: 'Rys2023Winners',

  components: { BarChart, WpContent },

  async setup() {
    const wpJson = useWp();
    const modal = useModal();

    const { data: page, error: pageError } = await useAsyncData(
      'page-2023winners',
      () => wpJson.pages.getBySlug('2023winners')
    );

    if (pageError.value) {
      throw createError({ status: 500, cause: pageError.value });
    }

    if (!page.value) {
      throw createError({ statusCode: 404 });
    }

    return { page, modal };
  },

  data() {
    return {
      c1_pause: true,
      c2_pause: true,
      c3_pause: true,
      embed: '<iframe width="560" height="315" src="https://www.youtube.com/embed/SXqrcGLT8Ag?si=MwDtLamku2ufCJir" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
    };
  },

  head() {
    return yoastToVueMeta(this.page);
  },

  mounted() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.66
    };

    const observer1 = new IntersectionObserver(this.onIntersection1, options);
    observer1.observe(this.$refs.c1.$el);

    const observer2 = new IntersectionObserver(this.onIntersection2, options);
    observer2.observe(this.$refs.c2.$el);

    const observer3 = new IntersectionObserver(this.onIntersection3, options);
    observer3.observe(this.$refs.c3.$el);
  },

  methods: {
    onIntersection1(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.c1_pause = false;
        }
      });
    },

    onIntersection2(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.c2_pause = false;
        }
      });
    },

    onIntersection3(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.c3_pause = false;
        }
      });
    },

    showEmbedModal(embed) {
      this.modal(EmbedModal, this, {
        props: { embed }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-section {
  background: $thd-black;

  @media screen and (min-width: $breakpoint-lg) {
    padding-top: 40px;
  }

  @media screen and (min-width: $breakpoint-sm) {
    padding-bottom: 24px;
  }

  p.top-text {
    color: $thd-tan;
    font-size: 14px;
    line-height: 18px;
  }

  h1.banner-text::v-deep {
    color: $thd-white;
    font-size: 46px;
    line-height: 52px;
    font-weight: 700;
    margin-top: 0;
    text-transform: uppercase;
    font-stretch: condensed;

    @media screen and (min-width: $breakpoint-lg) {
      font-size: 96px;
      line-height: 96px;
    }

    strong {
      color: $thd-orange;
      font-weight: 700;
    }
  }

  .sub-text {
    color: $thd-white;
    font-size: 18px;
    line-height: 24px;
  }

  hr {
    width: 60px;
    color: $thd-tan;
    margin: 40px 0 20px;
  }

  .btn {
    margin: 40px 0 28px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    @media screen and (min-width: $breakpoint-lg) {
      margin: 80px 16px 46px;
    }
  }
}

.middle {
  margin: 60px auto;

  @media screen and (max-width: $breakpoint-lg) {
    margin: 48px auto;
    padding: 0;
    border: none;
  }

  h2::v-deep {
    font-size: 46px;
    line-height: 52px;
    margin: 0;

    @media screen and (min-width: $breakpoint-lg) {
      font-size: 80px;
      line-height: 80px;
    }

    strong {
      color: $thd-orange;
    }
  }

  hr {
    width: 60px;
    color: $thd-tan;
    margin: 40px 0 20px;
  }

  h3 {
    font-stretch: normal;
    font-size: 32px;
    line-height: 40px;
    font-weight: 500;
  }

  .content::v-deep {
    font-size: 18px;
    line-height: 28px;

    a {
      color: $thd-orange;
      text-decoration: none;
    }
  }

  caption {
    display: block;
    width: calc(100% - 48px);
    color: $thd-orange;
    font-size: 20px;
    line-height: 28px;
    padding: 0 24px;
    text-align: left;
    margin-top: 28px;
  }
}

.bottom {
  background: $thd-black;
  padding: 100px 0 136px;
  color: $thd-white;

  @media screen and (max-width: $breakpoint-lg) {
    padding: 48px 0;
  }

  p {
    font-size: 18px;
    line-height: 28px;
    margin: 0;
  }

  h2::v-deep {
    font-size: 46px;
    line-height: 52px;
    margin: 0 0 80px;

    @media screen and (min-width: $breakpoint-lg) {
      font-size: 76px;
      line-height: 76px;
    }

    strong {
      color: $thd-orange;
    }
  }
}

.middle-embed::v-deep {
  p {
    font-size: 24px;
  }

  li {
    font-size: 24px;
  }

  .winners {
    h2 {
      font-size: 36px;
      margin: 0 auto;
    }

    .cluster {
      list-style-type: none;
      padding: 24px 12px;
      margin: 18px auto;
      background: #fafafa;
      counter-reset: school;

      .school {
        padding: 12px;
        margin: 0 0 12px;
        font-size: 20px;
        line-height: 28px;

        @media screen and (min-width: $breakpoint-lg) {
          display: flex;
        }

        &::before {
          @media screen and (min-width: $breakpoint-lg) {
            counter-increment: school;
            content: counter(school);
            width: 3rem;
            line-height: 2;
            font-weight: 600;
          }
        }

        &:first-child {
          display: none;

          @media screen and (min-width: $breakpoint-lg) {
            display: flex;
            margin-left: 3rem;
            font-weight: 600;

            &::before {
              content: none;
            }
          }
        }

        &:nth-child(even) {
          background: #efefef;
        }

        .school-name {
          font-size: 18px;
          margin: 0;
          padding-left: 1.5rem;
          position: relative;

          &::before {
            display: inline-block;
            counter-increment: school;
            content: counter(school);
            width: 1.5rem;
            position: absolute;
            top: 0;
            left: 0;
          }

          @media screen and (min-width: $breakpoint-lg) {
            font-size: 22px;
            margin: 0 12px 0 0;
            padding-left: 0;

            &::before {
              content: none;
            }
          }
        }

        .votes {
          flex-grow: 1;
          text-align: left;
          margin-left: 1.5rem;
          display: none;

          &::before {
            content: 'Total Votes: ';
          }

          @media screen and (min-width: $breakpoint-lg) {
            text-align: right;
            margin: 0 24px 0 0;

            &::before {
              content: none;
            }
          }
        }

        .prize {
          text-align: left;
          margin-left: 1.5rem;
          flex-grow: 1;

          &::before {
            content: 'Grant Amount: ';
          }

          @media screen and (min-width: $breakpoint-lg) {
            text-align: right;
            min-width: 8rem;
            margin: 0;
            padding-right: 12px;

            &::before {
              content: none;
            }
          }
        }
      }
    }

    .ig-winners {
      margin-bottom: 48px;
    }
  }
}

.post-content.post-content.post-content ::v-deep {
  h2 {
    margin-top: 48px;
  }
}
</style>
